import React from 'react';

import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import { Question } from 'types/question.types';
import { QuestionPreview } from '@event-editor/components/QuestionPreview';

interface QuestionnairePreviewModalProps extends React.ComponentProps<typeof Modal> {
  questions: (Question | null)[];
}

const QuestionnairePreviewModal = ({
  questions,
  ...props
}: QuestionnairePreviewModalProps): React.ReactElement => {
  const validQuestions = questions.filter((q): q is Question => q !== null);

  return (
    <Modal {...props} modal>
      <ModalContent
        size="md"
        className="tw-flex tw-max-h-[80vh] tw-flex-col"
        data-testid="questionnaire-preview-modal"
      >
        <ModalHeader className="tw-mb-2">
          <ModalTitle className="tw-text-dark-black">Complete your registration</ModalTitle>
        </ModalHeader>
        <div className="tw-mb-5 tw-text-sm tw-leading-4 tw-text-primary-grey">
          Fill out this questionnaire to complete your registration for this event.
        </div>
        <div
          className="
            tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden [&_*]:tw-pointer-events-none [&_*]:tw-cursor-default
          "
        >
          {validQuestions.map((question) => (
            <QuestionPreview key={question.id} question={question} />
          ))}
        </div>
      </ModalContent>
    </Modal>
  );
};

export { QuestionnairePreviewModal };
